import {
  useElementSize
} from "./useElementSize.js";
import { validateTidalLicense } from "../../base/index.js";
validateTidalLicense();
export {
  useElementSize
};
//# sourceMappingURL=index.js.map
